import { useRef } from 'react'
import { useDeliveryAppContext } from '@/context/deliveryApp/DeliveryAppContext'
import { useRipple } from '@/hooks/useRipple'

const CallButton = () => {
  const { pageProps } = useDeliveryAppContext()

  const ref = useRef(null)
  useRipple(ref, 'rgb(169, 174, 179, 0.3)')

  return (
    <div>
      <div
        ref={ref}
        className="relative w-12 h-12 p-3 overflow-hidden rounded-full"
      >
        <a href={`tel: ${pageProps?.settings?.logistics_manager_phone?.valor}`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            fill="#6b7280"
          >
            <path d="M256 0C112.9 0 4.583 119.1 .0208 256L0 309.2C0 350.5 32.75 384 73.14 384h18.29C111.6 384 128 367.3 128 346.6V213.4C128 192.7 111.6 176 91.43 176H73.14c-3.277 0-6.344 .7148-9.498 1.148C94.8 101.5 169.3 48.2 256 48.19c86.74 .0117 161.2 53.36 192.4 128.1C445.2 176.7 442.1 176 438.9 176h-18.29C400.4 176 384 192.7 384 213.4v133.2C384 367.3 400.4 384 420.6 384h18.29c8.875 0 17.27-1.861 25.14-4.82V400c0 22.06-17.94 40-40 40h-110.7C305 425.7 289.7 416 272 416h-32C213.5 416 192 437.5 192 464S213.5 512 239.1 512H272c17.72 0 33.03-9.711 41.34-24H424c48.53 0 88-39.47 88-88V256C507.4 119.1 399.1 0 256 0zM73.14 224H80v112H73.14C59.28 336 48 323.1 48 309.2V256c0-2.41 .2793-4.75 .3613-7.141C49.33 235 59.91 224 73.14 224zM438.9 336H432V224h6.857c13.23 0 23.81 11.04 24.78 24.86C463.7 251.3 464 253.6 464 256v53.24C464 323.1 452.7 336 438.9 336z" />
          </svg>
          {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="M191.1 224c0-17.72-14.34-32.04-32-32.04L144 192c-35.34 0-64 28.66-64 64.08v47.79C80 339.3 108.7 368 144 368H160c17.66 0 32-14.36 32-32.06L191.1 224zM256 0C112.9 0 4.583 119.1 .0208 256L0 296C0 309.3 10.75 320 23.1 320S48 309.3 48 296V256c0-114.7 93.34-207.8 208-207.8C370.7 48.2 464 141.3 464 256v144c0 22.09-17.91 40-40 40h-110.7C305 425.7 289.7 416 272 416H241.8c-23.21 0-44.5 15.69-48.87 38.49C187 485.2 210.4 512 239.1 512H272c17.72 0 33.03-9.711 41.34-24H424c48.6 0 88-39.4 88-88V256C507.4 119.1 399.1 0 256 0zM368 368c35.34 0 64-28.7 64-64.13V256.1C432 220.7 403.3 192 368 192l-16 0c-17.66 0-32 14.34-32 32.04L320 335.9C320 353.7 334.3 368 352 368H368z" />
          </svg> */}
        </a>
      </div>
    </div>
  )
}

export default CallButton
